
export default {
  props: {
    icon: {
      default: "",
    },
    iconSingle:{
      default:false
    },
    iconFill: {
      default: "",
    },
    ratingDecimals: { default: 2 },
    rating: {
      default: 0,
    },
    hideNumber:{
      default:false
    },
    hideCount:{
      default:false
    },
    count: {
      default: 0,
    },
    countLabel:{
      default:''
    }
  },
  data() {
    return {};
  },
  computed: {
    sum() {},
  },
};
